import * as myxhr from "./myxhr.js";

export function get() {
    return myxhr.get('/assessmentstate');
}